/* ===========================
   Custom Cart Drawer (no Kalles deps)
   =========================== */

const CCD = (() => {
  const els = {
    drawer:  () => document.getElementById('custom-cart-drawer'),
    overlay: () => document.querySelector('[data-ccd-overlay]'),
    items:   () => document.querySelector('[data-ccd-items]'),
    subtotal:() => document.querySelector('[data-ccd-subtotal]')
  };

  /* ---------- Open / Close ---------- */
  function open() {
    const d = els.drawer(); const o = els.overlay();
    if (!d || !o) return;
    d.setAttribute('aria-hidden','false');
    o.classList.add('is-open');
    document.documentElement.classList.add('overflow-hidden');
  }

  function close() {
    const d = els.drawer(); const o = els.overlay();
    if (!d || !o) return;
    d.setAttribute('aria-hidden','true');
    o.classList.remove('is-open');
    document.documentElement.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ccd-close]')) { e.preventDefault(); close(); }
    if (e.target.closest('[data-ccd-overlay]')) { e.preventDefault(); close(); }
  });

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    // Uses Shopify's money format if present; fallback INR with 2 decimals
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.Shopify.currency?.active ? '{{ amount_with_comma_separator }}' : '{{ amount }}');
    }
    return '₹' + (cents/100).toFixed(2);
  }

  /* ---------- Render ---------- */
  function render(cart) {
    const ul = els.items(); const sub = els.subtotal();
    if (!ul || !sub) return;

    // Build line items
    ul.innerHTML = cart.items.map((it) => {
      const img = it.image ? `<img src="${it.image}" alt="${it.title}" class="w-16 h-16 object-cover rounded">` : '';
      const props = it.properties ? Object.entries(it.properties)
        .filter(([k,v]) => v) // omit empty
        .map(([k,v]) => `<div class="text-xs text-gray-500">${k}: ${v}</div>`).join('') : '';

      return `
      <li class="p-4 flex gap-3 items-start" data-key="${it.key}">
        ${img}
        <div class="min-w-0 flex-1">
          <div class="text-sm font-medium line-clamp-2">${it.product_title || it.title}</div>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="text-xs text-gray-500">${it.variant_title}</div>` : ''}
          ${props}
          <div class="mt-2 flex items-center justify-between">
            <div class="text-sm">${formatMoney(it.final_line_price)}</div>
            <div class="flex items-center gap-2">
              <button class="px-2 py-1 border rounded" data-ccd-qty="-1" aria-label="Decrease">−</button>
              <span class="text-sm" data-ccd-qty-display>${it.quantity}</span>
              <button class="px-2 py-1 border rounded" data-ccd-qty="+1" aria-label="Increase">+</button>
              <button class="ml-2 text-xs text-red-600" data-ccd-remove>Remove</button>
            </div>
          </div>
        </div>
      </li>`;
    }).join('');

    sub.textContent = formatMoney(cart.items_subtotal_price);
  }

  /* ---------- Data ---------- */
  async function getCart() {
    const res = await fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    // Ensure file uploads & properties are handled
    if (!form.hasAttribute('enctype')) form.setAttribute('enctype','multipart/form-data');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    });
    if (!res.ok) {
      let msg = 'Unable to add to cart.'; try { const j = await res.json(); msg = j?.description || msg; } catch {}
      throw new Error(msg);
    }
  }

  async function changeLine(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!res.ok) throw new Error('change.js failed');
    return res.json();
  }

  /* ---------- Intercepts ---------- */
  // Intercept ALL add-to-cart forms
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    try {
      await addToCart(form);
      const cart = await getCart();
      render(cart);
      open();
      document.dispatchEvent(new CustomEvent('ccd:refresh', { detail: cart }));
    } catch (err) {
      console.warn('[CCD] add error', err);
      alert(err.message || 'Add to cart failed.');
    }
  });

  // Delegate qty and remove inside drawer
  document.addEventListener('click', async (e) => {
    const li = e.target.closest('[data-key]');
    if (!li) return;

    const key = li.getAttribute('data-key');
    const qtyEl = li.querySelector('[data-ccd-qty-display]');
    let qty = parseInt(qtyEl?.textContent || '1', 10);

    if (e.target.closest('[data-ccd-qty="-1"]')) qty = Math.max(0, qty - 1);
    if (e.target.closest('[data-ccd-qty="+1"]')) qty = qty + 1;
    if (e.target.closest('[data-ccd-remove]')) qty = 0;

    if (qty === parseInt(qtyEl?.textContent || '0', 10)) return;

    try {
      const newCart = await changeLine(key, qty);
      render(newCart);
      if (!newCart.item_count) close();
      document.dispatchEvent(new CustomEvent('ccd:refresh', { detail: newCart }));
    } catch (err) {
      console.warn('[CCD] change error', err);
    }
  });

  // Optional: respond to external cart refreshes
document.addEventListener('ccd:refresh', async () => {
  try { render(await getCart()); } catch {}
});

  // First paint: keep drawer synced if user lands with items
  (async () => { try { render(await getCart()); } catch {} })();

  return { open, close, render, getCart };
})();
